import {
  LOGOUT,
  LOGIN_ERROR,
  LOGIN_SUCCESS,
  VERIFY_SAGA,
  VERIFY_ERROR,
  VERIFY_SUCCESS,
  LOGIN_SAGA,
} from "../actionTypes";

import http from "../../services/http";

const INITIAL_STATE = {
  token: http.getToken() || null,
  loginError: null,
  verifyError: null,
  loginSuccess: false,
  verifySuccess: false,
  loading: false,
};

const userReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case LOGOUT:
      http.removeToken();
      return {
        ...state,
        token: null,
      };
    case LOGIN_SAGA:
      return {
        ...state,
        loading: true,
        loginError: null,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loginError: null,
        loading: false,
        loginSuccess: true,
      };
    case LOGIN_ERROR:
      return {
        ...state,
        loginError: "login failed",
        loading: false,
      };
    case VERIFY_SAGA:
      return {
        ...state,
        loginError: null,
        loading: true,
      };
    case VERIFY_ERROR:
      return {
        ...state,
        loading: false,
        verifyError: "verify failed",
      };
    case VERIFY_SUCCESS:
      http.setToken(payload);
      return {
        ...state,
        loading: false,
        verifyError: null,
        token: payload,
        verifySuccess: true,
      };
    default:
      return state;
  }
};
export default userReducer;
